<template>
  <div class="inside-modal">
    <!-- ============= Logo / title =============  -->
    <div class="row f-row text-center">
      <div class="col col-12 mt-5">
        <img
          :src="logo"
          @mouseover="logo = logo_blue"
          @mouseout="logo = logo_white"
          height="30"
          alt=""
          style="padding: 0"
        />
      </div>
    </div>
    <div
      class="row f-row text-center"
      style="border-bottom: 1px solid var(--graylightbackground) !important;"
    >
      <div class="col col-12 mt-1 mb-3">
        {{ createEditTextExpoCommodities }}
      </div>
    </div>
    <!-- ============= form =============  -->
    <div class="row f-row mt-3">
      <div class="col col-1"></div>
      <div class="col col-10">
        <form @submit.prevent="validateBeforeSubmitCommodities">
          <!-- https://logaretm.github.io/vee-validate/guide/basics.html#validation-provider -->
          <!-- ============= required fields =============  -->
          Required fields:<br />
          <table
            class="table table-sm table-responsive table-borderless table-data-controls my-data-table"
            style="width: 100%;"
          >
            <tbody>
              <tr>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('portolio')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Portfolio
                  </label>
                  <input
                    v-validate="'required|max:150'"
                    class="custom-input-2"
                    name="portolio"
                    placeholder="Portfolio Name"
                    v-model="newEditedItemExpo.fk_idportfolio"
                    :class="{
                      input: true,
                      'is-danger': errors.has('portolio'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label"
                    >Commodity
                    <span style="color: var(--textactive)"
                      >({{ newEditedItemExpo.quotation }})</span
                    >
                  </label>
                  <select
                    class="dropdown-form dropdown-sm"
                    v-model="newEditedItemExpo.fk_idcommodity"
                    @change="onCrudExpoCommodity"
                  >
                    <option
                      v-for="commodity in allCommodities"
                      v-bind:value="commodity.fk_idproduct"
                      :key="commodity.fk_idproduct"
                      >{{ commodity.fk_idproduct.toUpperCase() }}</option
                    >
                  </select>
                </td>
                <td class="my-data-td">
                  <label class="txt-label">Exposure Type</label>
                  <select
                    class="dropdown-form dropdown-sm"
                    v-model="newEditedItemExpo.fk_idcommodityexposureoption"
                  >
                    <option
                      v-for="type in expoOptionsCommodities"
                      v-bind:value="type.name"
                      :key="type.id"
                      >{{ type.name.toUpperCase() }}</option
                    >
                  </select>
                </td>
                <td class="my-data-td">
                  <label class="txt-label">Pricing method</label>
                  <select
                    class="dropdown-form dropdown-sm"
                    v-model="newEditedItemExpo.fk_idpricingmethod"
                  >
                    <option
                      v-for="type in pricingMethods"
                      v-bind:value="type.method"
                      :key="type.id"
                      >{{ type.method }}</option
                    >
                  </select>
                </td>
                <td class="my-data-td" style="width:1%!important;">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('date')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Date
                  </label>
                  <input
                    v-validate="'required|date_format:yyyy-MM-dd'"
                    style="height: 19px!important;"
                    type="date"
                    class="custom-input-2"
                    name="commodity_expo_date"
                    placeholder="yyyy-mm-dd"
                    v-model="newEditedItemExpo.date"
                    :class="{
                      input: true,
                      'is-danger': errors.has('date'),
                    }"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    Quantity
                    <span style="color: var(--textactive)">
                      ({{ newEditedItemExpo.commodity_unit }})
                    </span>
                  </label>
                  <InputNumber
                    style="height: 19px!important;"
                    :tableFormat="false"
                    :value="+newEditedItemExpo.quantity"
                    @input="(val) => onUserQuantityChange(val)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <!-- ============= conditional fields =============  -->
          Conditional fields (fill only one):<br />
          <table
            class="my-data-table table table-sm table-responsive table-borderless table-data-controls"
            style="width: 100%;"
          >
            <tbody>
              <tr>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="
                        errors.has('contract_month_year') ||
                          contractOrContinuation ||
                          contractAndContinuation ||
                          continuationCheck
                      "
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Futures Date
                  </label>
                  <input
                    v-validate="''"
                    class="custom-input-2"
                    name="contract_month_year"
                    placeholder="MMMYY"
                    v-model="newEditedItemExpo.contract_month_year"
                    :class="{
                      input: true,
                      'is-danger': errors.has('contract_month_year'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="
                        errors.has('continuation_month') ||
                          contractOrContinuation ||
                          contractAndContinuation
                      "
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Continuation month
                  </label>
                  <input
                    v-validate="'min_value:1|decimal:0'"
                    class="custom-input-2"
                    name="continuation_month"
                    placeholder="Positive integer"
                    v-model="newEditedItemExpo.continuation_month"
                    :class="{
                      input: true,
                      'is-danger': errors.has('continuation_month'),
                    }"
                    type="number"
                    step="1"
                  />
                </td>
                <td class="my-data-td"></td>
                <td class="my-data-td"></td>
                <td class="my-data-td"></td>
                <td class="my-data-td"></td>
              </tr>
            </tbody>
          </table>
          <!-- ============= optional fields =============  -->
          Optional fields:<br />
          <table
            class="my-data-table table table-sm table-responsive table-borderless table-data-controls"
            style="width: 100%;"
          >
            <tbody>
              <tr>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('sale_date')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Exposure End Date
                  </label>
                  <input
                    v-validate="'date_format:yyyy-MM-dd'"
                    type="date"
                    class="custom-input-2"
                    name="sale_date"
                    placeholder="yyyy-mm-dd"
                    v-model="newEditedItemExpo.sale_date"
                    :class="{
                      input: true,
                      'is-danger': errors.has('sale_date'),
                    }"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('shipping_date')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Shipping Date
                  </label>
                  <input
                    v-validate="'date_format:yyyy-MM-dd'"
                    type="date"
                    class="custom-input-2"
                    name="shipping_date"
                    placeholder="yyyy-mm-dd"
                    v-model="newEditedItemExpo.shipping_date"
                    :class="{
                      input: true,
                      'is-danger': errors.has('shipping_date'),
                    }"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('hedge_asset')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Hedged Asset
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="hedge_asset"
                    placeholder="Asset"
                    v-model="newEditedItemExpo.hedge_asset"
                    :class="{
                      input: true,
                      'is-danger': errors.has('hedge_asset'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('end_product')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    End Product Hedged
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="end_product"
                    placeholder="Product"
                    v-model="newEditedItemExpo.end_product"
                    :class="{
                      input: true,
                      'is-danger': errors.has('end_product'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('custom_name')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Custom Exposure Name
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="custom_name"
                    placeholder="Custom Name"
                    v-model="newEditedItemExpo.custom_name"
                    :class="{
                      input: true,
                      'is-danger': errors.has('custom_name'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('custom_id')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Custom Exposure Id
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="custom_id"
                    placeholder="Custom Id"
                    v-model="newEditedItemExpo.custom_id"
                    :class="{
                      input: true,
                      'is-danger': errors.has('custom_id'),
                    }"
                    type="text"
                  />
                </td>
              </tr>
              <tr>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('port')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Port
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="port"
                    placeholder="Port"
                    v-model="newEditedItemExpo.port"
                    :class="{
                      input: true,
                      'is-danger': errors.has('port'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('provider')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Provider Name
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="provider"
                    placeholder="Provider Name"
                    v-model="newEditedItemExpo.provider"
                    :class="{
                      input: true,
                      'is-danger': errors.has('provider'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('client')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Client Name
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="client"
                    placeholder="Client Name"
                    v-model="newEditedItemExpo.client"
                    :class="{
                      input: true,
                      'is-danger': errors.has('client'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('plant')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Plant Supplied/Production
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="plant"
                    placeholder="Plant Name"
                    v-model="newEditedItemExpo.plant"
                    :class="{
                      input: true,
                      'is-danger': errors.has('plant'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">Incoterm</label>
                  <select
                    class="dropdown-form dropdown-sm"
                    v-model="newEditedItemExpo.fk_idincoterms"
                  >
                    <option
                      v-for="type in incoterms"
                      v-bind:value="type.name"
                      :key="type.id"
                      >{{ type.name.toUpperCase() }}</option
                    >
                  </select>
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('base')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Base
                    <span style="color: var(--textactive)"
                      >({{ newEditedItemExpo.quotation }})</span
                    >
                  </label>
                  <input
                    v-validate="'decimal:2'"
                    data-vv-as="field"
                    class="custom-input-2"
                    name="base"
                    placeholder="Base"
                    v-model="newEditedItemExpo.base"
                    :class="{
                      input: true,
                      'is-danger': errors.has('base'),
                    }"
                    type="number"
                    step="0.000000000000000001"
                  />
                </td>
              </tr>
              <tr>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('freight')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Freight
                    <span style="color: var(--textactive)"
                      >({{ newEditedItemExpo.quotation }})</span
                    >
                  </label>
                  <input
                    v-validate="'decimal:2'"
                    data-vv-as="field"
                    class="custom-input-2"
                    name="freight"
                    placeholder="Freight Amount"
                    v-model="newEditedItemExpo.freight"
                    :class="{
                      input: true,
                      'is-danger': errors.has('freight'),
                    }"
                    type="number"
                    step="0.000000000000000001"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('insurance')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Insurance
                    <span style="color: var(--textactive)"
                      >({{ newEditedItemExpo.quotation }})</span
                    >
                  </label>
                  <input
                    v-validate="'decimal:2'"
                    class="custom-input-2"
                    name="insurance"
                    placeholder="Insurance Amount"
                    v-model="newEditedItemExpo.insurance"
                    :class="{
                      input: true,
                      'is-danger': errors.has('insurance'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('tariffs')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Tariff
                    <span style="color: var(--textactive)">(%)</span>
                  </label>
                  <input
                    v-validate="'decimal:2'"
                    data-vv-as="field"
                    class="custom-input-2"
                    name="tariff"
                    placeholder="Tariff"
                    v-model="newEditedItemExpo.tariffs"
                    :class="{
                      input: true,
                      'is-danger': errors.has('tariff'),
                    }"
                    type="number"
                    step="0.000000000000000001"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('bonus')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Bonus
                    <span style="color: var(--textactive)"
                      >({{ newEditedItemExpo.quotation }})</span
                    >
                  </label>
                  <input
                    v-validate="'decimal:2'"
                    data-vv-as="field"
                    class="custom-input-2"
                    name="bonus"
                    placeholder="Bonus"
                    v-model="newEditedItemExpo.bonus"
                    :class="{
                      input: true,
                      'is-danger': errors.has('bonus'),
                    }"
                    type="number"
                    step="0.000000000000000001"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('percent_bonus')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Percentage bonus
                    <span style="color: var(--textactive)">(%)</span>
                  </label>
                  <input
                    v-validate="'min_value:0|decimal:2'"
                    data-vv-as="field"
                    class="custom-input-2"
                    name="percent_bonus"
                    placeholder="Bonus percentage"
                    v-model="newEditedItemExpo.percent_bonus"
                    :class="{
                      input: true,
                      'is-danger': errors.has('percent_bonus'),
                    }"
                    type="number"
                    step="0.000000000000000001"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('comments')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Comments
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="comments"
                    placeholder="Comments"
                    v-model="newEditedItemExpo.comments"
                    :class="{
                      input: true,
                      'is-danger': errors.has('comments'),
                    }"
                    type="text"
                  />
                </td>
              </tr>
              <tr>
                <td class="my-data-td" v-show="auxDate < today">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('settlement_price')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Settlement Price
                    <span style="color: var(--textactive)"
                      >({{ newEditedItemExpo.quotation }})</span
                    >
                  </label>
                  <input
                    v-validate="'min_value:0|decimal:5'"
                    class="custom-input-2"
                    name="settlement_price"
                    placeholder="Price"
                    v-model="newEditedItemExpo.settlement_price"
                    :class="{
                      input: true,
                      'is-danger': errors.has('settlement_price'),
                    }"
                    type="number"
                    step="0.000000000000000001"
                  />
                </td>
                <td class="my-data-td" v-show="auxDate < today">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('settlement_pnl')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Settlement PnL
                    <span style="color: var(--textactive)"
                      >({{ newEditedItemExpo.quotation.slice(0, 3) }})</span
                    >
                  </label>
                  <input
                    v-validate="'decimal:2'"
                    class="custom-input-2"
                    name="settlement_pnl"
                    placeholder="Profit or Loss"
                    v-model="newEditedItemExpo.settlement_pnl"
                    :class="{
                      input: true,
                      'is-danger': errors.has('settlement_pnl'),
                    }"
                    type="number"
                    step="0.000000000000000001"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <!-- ============= Buttons =============  -->
          <div class="row f-row">
            <div
              class="col col-6 text-right align-right"
              style="padding-right: 5px;"
            >
              <button class="btn btn-sm btn-home" v-on:click="onUserCancel">
                Cancel
              </button>
            </div>
            <div
              class="col col-6 text-left align-left"
              style="padding-left: 5px;"
            >
              <button type="submit" class="btn btn-sm btn-home">
                Accept
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- ============= Show Errors =============  -->
    <div class="row f-row mt-3 mb-4">
      <div class="col col-1"></div>
      <div class="col col-10 btn-warn">
        <span v-show="errors.has('portolio')"
          >{{ errors.first("portolio") }}.<br
        /></span>
        <span v-show="errors.has('date')"
          >{{ errors.first("date") }}.<br
        /></span>
        <span v-show="errors.has('quantity')"
          >{{ errors.first("quantity") }}.<br
        /></span>
        <span v-show="errors.has('contract_month_year')"
          >{{ errors.first("contract_month_year") }}.<br
        /></span>
        <span v-show="errors.has('continuation_month')"
          >{{ errors.first("continuation_month") }}.<br
        /></span>
        <span v-show="contractOrContinuation"
          >Either "Contract month year" or "Continuation month" are required<br
        /></span>
        <span v-show="contractAndContinuation"
          >Only one of "Contract month year" and "Continuation month" are
          required<br
        /></span>
        <span v-show="continuationCheck"
          >Field should be 3 letter month, year: "MMMYY". Year must be between
          {{ minDate - 2000 }} and {{ maxDate - 2000 }} <br
        /></span>
        <span v-show="errors.has('hedge_asset')"
          >{{ errors.first("hedge_asset") }}.<br
        /></span>
        <span v-show="errors.has('end_product')"
          >{{ errors.first("end_product") }}.<br
        /></span>
        <span v-show="errors.has('custom_name')"
          >{{ errors.first("custom_name") }}.<br
        /></span>
        <span v-show="errors.has('custom_name')"
          >{{ errors.first("custom_name") }}.<br
        /></span>
        <span v-show="errors.has('custom_id')"
          >{{ errors.first("custom_id") }}.<br
        /></span>
        <span v-show="errors.has('port')"
          >{{ errors.first("port") }}.<br
        /></span>
        <span v-show="errors.has('provider')"
          >{{ errors.first("provider") }}.<br
        /></span>
        <span v-show="errors.has('client')"
          >{{ errors.first("client") }}.<br
        /></span>
        <span v-show="errors.has('plant')"
          >{{ errors.first("plant") }}.<br
        /></span>
        <span v-show="errors.has('base')"
          >{{ errors.first("base") }}.<br
        /></span>
        <span v-show="errors.has('freight')"
          >{{ errors.first("freight") }}.<br
        /></span>
        <span v-show="errors.has('insurance')"
          >{{ errors.first("insurance") }}.<br
        /></span>
        <span v-show="errors.has('tariffs')"
          >{{ errors.first("tariffs") }}.<br
        /></span>
        <span v-show="errors.has('bonus')"
          >{{ errors.first("bonus") }}.<br
        /></span>
        <span v-show="errors.has('percent_bonus')"
          >{{ errors.first("percent_bonus") }}.<br
        /></span>
        <span v-show="errors.has('comments')"
          >{{ errors.first("comments") }}.<br
        /></span>
        <span v-show="errors.has('settlement_price')"
          >{{ errors.first("settlement_price") }}.<br
        /></span>
        <span v-show="errors.has('settlement_pnl')"
          >{{ errors.first("settlement_pnl") }}.<br
        /></span>
      </div>
    </div>
  </div>
</template>

<script>
import InputNumber from "@/components/InputNumber";
import { timeParse } from "d3";
import moment from "moment";
import { prepDate } from "@/_core/_helpers/_helpers";

export default {
  name: "NewEditExpoCommodities",
  props: {
    createEditTextExpoCommodities: { required: true },
    editedItemExpoCommodities: { required: true },
    allCommodities: { required: true },
    expoOptionsCommodities: { required: true },
    incoterms: { required: true },
    pricingMethods: { required: true },
    colorTheme: { required: true, type: Boolean, default: true },
  },
  components: {
    InputNumber,
  },
  data() {
    return {
      logo_white: require("@/assets/images/QuanspireLogoWhite.svg"),
      logo_blue: require("@/assets/images/QuanspireLogoBlue.svg"),
      logo: require("@/assets/images/QuanspireLogoWhite.svg"),
      today: new Date(),
      minDate: new Date().getFullYear() - 10,
      maxDate: new Date().getFullYear() + 20,
      newEditedItemExpo: {
        base: "",
        edited: false,
        bonus: "",
        client: "",
        comments: "",
        continuation_month: "1",
        contract_month_year: "",
        custom_name: "",
        date: "2025-01-15",
        fk_idcommodity: "brent",
        fk_idcommodityexposureoption: "PURCHASE",
        fk_idincoterms: "CIF",
        fk_idportafolio: "IMPORTS",
        fk_idportfolio: "IMPORTS",
        fk_idpricingmethod: "SPOT",
        freight: "",
        insurance: "",
        issue_date: "",
        percent_bonus: "",
        pk: "pending",
        plant: "",
        provider: "",
        quantity: 1,
        quotation: "USD/bbl",
        settlement_pnl: "",
        settlement_price: "",
        settlement_rate: "",
        tariffs: "",
      },
    };
  },
  created() {
    this.createNewEdited();
  },
  mounted() {
    if (this.colorTheme) {
      this.logo_white = require("@/assets/images/QuanspireLogoWhite.svg");
      this.logo = require("@/assets/images/QuanspireLogoWhite.svg");
    } else if (!this.colorTheme) {
      this.logo_white = require("@/assets/images/QuanspireLogoBlack.svg");
      this.logo = require("@/assets/images/QuanspireLogoBlack.svg");
    }
  },
  watch: {
    colorTheme() {
      if (this.colorTheme) {
        this.logo_white = require("@/assets/images/QuanspireLogoWhite.svg");
        this.logo = require("@/assets/images/QuanspireLogoWhite.svg");
      } else if (!this.colorTheme) {
        this.logo_white = require("@/assets/images/QuanspireLogoBlack.svg");
        this.logo = require("@/assets/images/QuanspireLogoBlack.svg");
      }
    },
    editedItemExpoCommodities() {
      this.createNewEdited();
    },
  },
  computed: {
    continuationCheck() {
      let val = this.newEditedItemExpo.contract_month_year;
      if (this.contractAndContinuation) {
        return false;
      } else if (val.length === 0) {
        return false;
      } else if (val.length !== 5) {
        return true;
      }
      let res = true;
      let str = val.slice(0, 3);
      let num = val.slice(3, 5);
      if (
        [
          "JAN",
          "FEB",
          "MAR",
          "APR",
          "MAY",
          "JUN",
          "JUL",
          "AUG",
          "SEP",
          "OCT",
          "NOV",
          "DEC",
        ].includes(str.toUpperCase()) &&
        num >= this.minDate - 2000 &&
        num <= this.maxDate - 2000
      ) {
        res = false;
      }
      return res;
    },
    contractOrContinuation() {
      return (
        this.newEditedItemExpo.contract_month_year === "" &&
        this.newEditedItemExpo.continuation_month === ""
      );
    },
    contractAndContinuation() {
      return (
        this.newEditedItemExpo.contract_month_year !== "" &&
        this.newEditedItemExpo.continuation_month !== ""
      );
    },
    auxDate() {
      return timeParse("%Y-%m-%d")(this.newEditedItemExpo.date);
    },
  },
  methods: {
    createNewEdited() {
      this.newEditedItemExpo = JSON.parse(
        JSON.stringify(this.editedItemExpoCommodities),
      );
      this.newEditedItemExpo.fk_idcommodity = this.newEditedItemExpo.fk_idcommodity.toUpperCase();
      // Dates
      this.newEditedItemExpo.date = prepDate(this.newEditedItemExpo.date);
      this.newEditedItemExpo.sale_date = prepDate(
        this.newEditedItemExpo.sale_date,
      );
      this.newEditedItemExpo.shipping_date = prepDate(
        this.newEditedItemExpo.shipping_date,
      );

      this.newEditedItemExpo.issue_date = prepDate(
        this.newEditedItemExpo.issue_date,
      );
      this.newEditedItemExpo.expiration_date = prepDate(
        this.newEditedItemExpo.expiration_date,
      );
      this.newEditedItemExpo.planned_expiration_date = prepDate(
        this.newEditedItemExpo.planned_expiration_date,
      );
      this.newEditedItemExpo.realized_expiration_date = prepDate(
        this.newEditedItemExpo.realized_expiration_date,
      );
      this.newEditedItemExpo.hedged_date = prepDate(
        this.newEditedItemExpo.hedged_date,
      );
      this.newEditedItemExpo.sale_date = prepDate(
        this.newEditedItemExpo.sale_date,
      );
      this.newEditedItemExpo.shipping_date = prepDate(
        this.newEditedItemExpo.shipping_date,
      );

      if (this.newEditedItemExpo.contract_month_year !== "") {
        this.newEditedItemExpo.contract_month_year =
          +timeParse("%Y-%m-%dT%H:%M:%S.%LZ")(
            this.newEditedItemExpo.contract_month_year,
          ) < +new Date(1980, 1, 1)
            ? ""
            : moment(String(this.newEditedItemExpo.contract_month_year))
                .format("MMMYY")
                .toUpperCase();
      }
      if (this.newEditedItemExpo.continuation_month == null) {
        this.newEditedItemExpo.continuation_month = "";
      } else if (this.newEditedItemExpo.continuation_month !== "") {
        if (!Number.isInteger(this.newEditedItemExpo.continuation_month)) {
          if (this.newEditedItemExpo.contract_month_year === "") {
            this.newEditedItemExpo.continuation_month = 1;
          } else {
            this.newEditedItemExpo.continuation_month = "";
          }
        }
      }
    },
    onCrudExpoCommodity(event) {
      let idx = event.target.options.selectedIndex;
      let item = this.allCommodities[idx].fk_idproduct;
      this.newEditedItemExpo.commodity_unit = this.allCommodities[
        idx
      ].fk_idunit;
      this.newEditedItemExpo.quotation =
        this.allCommodities[idx].fk_idcurrency +
        "/" +
        this.allCommodities[idx].fk_idunit;
      this.newEditedItemExpo.fk_idcommodity = item;
    },
    validateBeforeSubmitCommodities() {
      if (!this.contractOrContinuation && !this.contractAndContinuation) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            if (
              JSON.parse(JSON.stringify(this.editedItemExpoCommodities)) ===
                JSON.parse(JSON.stringify(this.newEditedItemExpo)) &&
              this.createEditTextExpoCommodities === "Edit Exposure"
            ) {
              this.$emit("eventCancelModalExpoCommodities");
            } else {
              this.newEditedItemExpo.edited = true;
              this.$emit(
                "eventValidatedExpoCommodities",
                this.newEditedItemExpo,
              );
            }
          }
        });
      }
    },
    onUserCancel() {
      this.$emit("eventCancelModalExpoCommodities");
    },
    onUserQuantityChange(val) {
      this.newEditedItemExpo.quantity = Math.max(0.01, val);
    },
  },
};
</script>
